export function Skeleton({ className = '', style }) {
  return <div className={`skeleton ${className}`} style={style} />;
}

// Dashboard ilk yükleme iskeleti
export function StatSkeleton() {
  return (
    <div className="card stat">
      <Skeleton className="sk-text" style={{ width: '45%' }} />
      <Skeleton className="sk-value" style={{ marginTop: 14 }} />
      <Skeleton className="sk-text" style={{ width: '30%', marginTop: 16 }} />
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div className="card chart-card">
      <Skeleton className="sk-title" />
      <Skeleton className="sk-block" />
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="page-enter">
      <Skeleton className="sk-text" style={{ width: 180, height: 26 }} />
      <Skeleton className="sk-text" style={{ width: 260, marginBottom: 28 }} />
      <div className="stat-row">
        <StatSkeleton />
        <StatSkeleton />
        <StatSkeleton />
      </div>
      <ChartSkeleton />
    </div>
  );
}
